import { createContext } from 'react';

export { Price } from './price'
export * from './navication'
export * from './methods'

export const Context = createContext();